import { React, useState, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import { styles } from './Modal.scss';

const cx = classNames.bind(styles);

export const ModalContext = React.createContext();

export const Modal = ({ isOpen, onClose, children, className, ...props }) => {
  const classes = cx('c-auth-modal', className);

  const [direction, setDirection] = useState();

  return (
    <ModalContext.Provider
      value={{
        direction,
        setDirection: value => setDirection(value),
      }}>
      <ReactModal
        isOpen={isOpen}
        onAfterOpen={() => {
          setTimeout(() => {
            document.body.classList.add('c-auth-modal__body--is-opened');
          }, 1000);
        }}
        onAfterClose={() => {
          setTimeout(() => {
            document.body.classList.remove('c-auth-modal__body--is-opened');
          }, 10);
        }}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        bodyOpenClassName="c-auth-modal__body--active"
        overlayClassName="c-auth-modal-overlay"
        closeTimeoutMS={1000}
        className={classes}
        ariaHideApp={false}
        {...props}>
        <div className="c-auth-modal-wrapper">
          <div className="c-auth-modal-click-capture" onClick={onClose} />
          <div className="c-auth-modal-inner">{children}</div>
        </div>
      </ReactModal>
      <div style={{ display: 'none' }}>
        <svg>
          <filter id="turbulence" x="0" y="0" width="100%" height="100%">
            <feTurbulence
              id="wave-filter"
              numOctaves="1"
              seed="2"
              baseFrequency="0.01 0.05"></feTurbulence>
            <feDisplacementMap
              scale="40"
              in="SourceGraphic"></feDisplacementMap>
            <animate
              xlinkHref="#wave-filter"
              attributeName="baseFrequency"
              dur="40s"
              keyTimes="0;0.5;1"
              values="0.01 0.01;0.02 0.03;0.01 0.01"
              repeatCount="indefinite"
            />
          </filter>
        </svg>
      </div>
    </ModalContext.Provider>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.any,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

Modal.defaultProps = {
  isOpen: false,
  onClose: null,
  className: '',
};
